export const getHomeUrl = () => "/";
export const getCourseUrl = (id) => `/courses/${id}`;
export const getJobUrl = (id) => `/jobs/${id}`;
export const getAcademyUrl = (id) => `/academies/${id}`;
export const getSkillPathUrl = (id) => `/skill-paths/${id}`;
export const getSkillUrl = (id) => `/skills/${id}`;
export const getProfileUrl = () => "/profile";
export const getMyProgressUrl = (tabName = null) =>
  tabName ? `/my-progress/${tabName}` : "/my-progress";
